const main_banner_video = require('../../components/main_banner_video/main_banner_video.script');
const rellax = require('../../components/rellax/rellax.script');
const carroucel = require('../../components/carousel/carousel.script');
import tippy from 'tippy.js';
import {
    tns
} from 'tiny-slider/src/tiny-slider';
var sliders = {};
export async function load() {

    try {
        await rellax.start('.rellax');
        await  carroucel.start()

        var reedMoreButton = document.getElementById("reedMoreButton")
        reedMoreButton.addEventListener("click", (e) => {
            var seeMore = document.getElementById("seeMore")
            if (seeMore.classList.contains("close")) {
                seeMore.classList.remove("close");
                seeMore.classList.add("open");
                seeMore.style.height = "auto";
                reedMoreButton.innerHTML = "Fechar";
            } else {
                seeMore.classList.remove("open");
                seeMore.classList.add("close");
                seeMore.style.height = "260px";
                reedMoreButton.innerHTML = "Leia mais...";
            }
        })

        var slider1 = tns({
            container: '.slider-box-color-quem',
            slideBy: 'page',
            autoplay: false,
            center: false,
            swipeAngle: false,
            loop: false,
            controls: false,
            responsive: {
                360: {
                    items: 1,
                    fixedWidth: false,
                    autoWidth: true,
                    gutter: 0,
                    edgePadding: 0,
                    controls: false,
                    nav: true,
                    navPosition: 'bottom',
                },
                992: {
                    items: 3,
                    fixedWidth: false,
                    autoWidth: true,
                    edgePadding: 0,
                    gutter: 30,
                    controls: false,
                    nav: false,
                }
            }
        });

        var slider2 = tns({
            container: '.slider-box-piramide',
            slideBy: 'page',
            autoplay: false,
            center: false,
            swipeAngle: false,
            loop: false,
            controls: false,
            responsive: {
                360: {
                    items: 1,
                    fixedWidth: false,
                    autoWidth: true,
                    gutter: 0,
                    edgePadding: 0,
                    controls: false,
                    nav: true,
                    navPosition: 'bottom',
                },
                992: {
                    items: 2,
                    fixedWidth: false,
                    autoWidth: true,
                    edgePadding: 0,
                    gutter: 30,
                    controls: false,
                    nav: false,
                }
            }
        });
        sliders = slider1, slider2;




        tippy('.redTip', {
            content: `
            <div class="tooltip red">Focada nas necessidades básicas do indivíduo. Ou seja, em prover formas de acesso a questões como alimentação e saúde.</div>
            `,
            allowHTML: true,
            animation: 'scale',
            placement: 'left'
        });

        tippy('.orangeTip', {
            content: `
            <div class="tooltip orange">Nesta fase, após ter as necessidades básicas atendidas, o foco consiste em prover segurança e estabilidade.</div>
            `,
            allowHTML: true,
            animation: 'scale',
            placement: 'left'
        });

        tippy('.yellowTip', {
            content: `
            <div class="tooltip yellow">Este é o momento de prover ao assistido formas de capacitá-lo profissionalmente e socialmente por meio de programas sociais e cursos profissionalizantes e técnicos.</div>
            `,
            allowHTML: true,
            animation: 'scale',
            placement: 'left'
        });

        tippy('.greenTip', {
            content: `
            <div class="tooltip green">Aqui, o assistido pode ser inserido no mercado e receber conhecimento social. Esta fase também conta com a aquisição de produtos de ONGs.</div>
            `,
            allowHTML: true,
            animation: 'scale',
            placement: 'left'
        });

        tippy('.purpleTip', {
            content: `
            <div class="tooltip purple">Nesta etapa, o assistido deve chegar ao fim da sua jornada de inclusão como membro ativo da sociedade, com realizações pessoais e evolução constante.</div>
            `,
            allowHTML: true,
            animation: 'scale',
            placement: 'left'
        });
        return true

    } catch (err) {
        console.log('err', err)
        return err
    }
}
